import * as React from "react";
import { useFormContext } from "react-hook-form";
import NGAlert from "../../../newcomponents/alert";
import { DomainInput } from "./types/input";

export const CreateNGAdvancedWorkloadSubdomainExactlyOneRouteCheck: React.FC = () => {
  const { watch } = useFormContext<DomainInput>();

  const fRoutingMode = watch("advanced.spec.routingMode") || "";
  const fPortActiveKey = watch("portActiveKey") || "";
  const fPorts = watch("advanced.spec.ports") || [];

  if (fRoutingMode !== "workloadSubdomain") {
    return null;
  }

  if (fPorts.some((p) => (p.routes || []).length !== 1)) {
    const currentPort = fPorts.find((p) => p.id === fPortActiveKey);
    const margin = currentPort && (currentPort.routes || []).length > 0 ? "mb-8 -mt-4" : "mt-4";

    return (
      <>
        <NGAlert
          className={`${margin}`}
          type={`error`}
          title="Workload Subdomain Requirement"
          message="Routing Mode Workload Subdomain requires each port to have exactly one route defined"
        />
      </>
    );
  }

  return null;
};
